<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Ventas Mercancía</span>
            <v-spacer></v-spacer>
            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( ventasmercancia  , 'ventasmercancia')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="mr-2"
              @click="getClientes, dialog = true"
              small
              tile
            >
              <v-icon small>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              color="orange"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="2">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="fechaini"
                  type="date"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="2">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  v-model="fechafin"
                  type="date"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  single-line
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>

              <v-col cols="12" md="2" class="black--text">
                <div><b>EFECTIVO:</b> {{ formatMoney( totalEfectivo ) }}</div>
                <div><b>TARJETA:</b>  {{ formatMoney( totalTarjeta ) }}</div>
                <div><b>TOTAL:</b>    {{ formatMoney( total ) }}</div>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="filterVentasmercancia"
                  class="elevation-0"
                  :search="search"
                  :page.sync="page"
                  @page-count="pageCount = $event"
                  :mobile-breakpoint="100"
                  hide-default-footer
                  dense
                >

                  <template v-slot:item.actions="{ item }">
                    <v-btn 
                      color="primary" 
                      x-small
                      @click="editItem(item)"
                      class="mr-2"
                    >
                      <v-icon small>mdi-magnify</v-icon>
                    </v-btn>

                    <v-btn 
                      color="error" 
                      x-small
                      @click="deleteItem(item)"
                      class="mr-2"
                      v-if="[94,93].includes( getdatosUsuario.idusuarios )"
                    >
                      <v-icon small> mdi-delete</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:item.estatus="{ item }">
                    <v-chip color="grey" dark small v-if="!item.estatus">Pendiente</v-chip>
                    <v-chip color="green" dark small v-if="item.estatus">Entregado</v-chip>
                  </template>

                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                      small
                    >
                      Actualizar
                    </v-btn>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="800px"
      persistent
    >
      <v-card>
      	<v-card-title>Datos de la compra</v-card-title>
      	<v-card-text class="black--text">
      		
      		<div><b>Cliente</b>  : {{ editedItem.cliente     }} </div>
      		<div><b>Pagado</b>   :  $ {{ editedItem.pago     }}.00 </div>
      		<div><b>Total</b>    :  $ {{ editedItem.total    }}.00 </div>
          <div><b>Autorizó</b> :  {{ editedItem.autorizo }} </div>
      		<div><b>Vendedor</b> :  {{ editedItem.nombre_completo }} </div>
          <div><b>Folio ticket</b>   :  {{ editedItem.folio_pago }} </div>

      		<v-data-table
            :headers="headersMercancia"
            :items="editedItem.detalle"
            class="elevation-0"
            v-if="editedItem.detalle"
            hide-default-footer
            :items-per-page="editedItem.detalle.lenght"
          >
          	<template v-slot:item.total="{ item }">
              {{ ( item.cantidad * item.precio ).toFixed( 2 ) }}
            </template>

          </v-data-table>

      	</v-card-text>
      	<v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          	@click="dialogConfirmaEntrega = true"
          	color="primary"
          	dark
          >Confirmar</v-btn>

          <v-btn
            @click="dialog = false"
            color="primary"
            dark
            absolute
            top
            right
          ><v-icon>mdi-close</v-icon></v-btn>

         </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar la venta?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                    <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
                    <!-- Guardar la información  -->
                    <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogConfirmaEntrega" max-width="500px">
      <v-card>
        <v-card-title>
          ¿Estás seguro de confirmar está entrega?
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            @click="dialogConfirmaEntrega = false"
          >Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark
            @click="saveCompra( )"
          >Sí, confirmo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],
    
    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idcontratos:0,
        idproveedores:0,
        articulo:0,
        precio:null,
        fecha_creacion:null,
        deleted:null,
      },

      defaultItem: {
        idcontratos:0,
        idproveedores:0,
        articulo:0,
        precio:null,
        personas:0,
        precio:0,
        fecha_creacion:null,
        deleted:null,
      },

      // Filtros: 
      incio:null,
      fin:null,

      // tabla
      search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      ventasmercancia: [],

      headers: [
        { text: 'ID'            , value: 'idventas_mercancia'    },
        { text: 'Vendedor'      , value: 'vendedor'           },
        { text: 'Autorizó'      , value: 'autorizo'           },
        { text: 'Extra'         , value: 'extra'              },
        { text: 'Cantidad'      , value: 'cantidad'           },
        { text: 'Total'         , value: 'total'              },
        { text: 'Estatus'       , value: 'estatus'            },
        { text: 'Alta'          , value: 'fecha_creacion'     },
        { text: 'Actions'       , value: 'actions', sortable: false },
      ],
      departamentos:[],

      proveedores: [],
      horarios:[],
      clientes:[],
      extras:[],
      articulos:[],
      platillos:[],
      e1: 1,
      clienteManual: false,
      cliente: null,
			email: null,
			telefono: null,
			direccion: null,
			festejado:'',
      dia: null,
      hora:null,
      tematica:null,
      porcumplir:null,

      sucursales:[],

      sucursal: null,

      searchArticulos:'',
      headersArticulos: [
        { text: 'ID'            , value: 'idarticulos'    },
        { text: 'Adicional'     , value: 'adicional'      },
        { text: 'Proveedor'     , value: 'proveedor'      },
        { text: 'Artículo'      , value: 'articulo'       },
        { text: 'Precio'        , value: 'precio'         },
      ],
      articulosSeleccionados: [],

      searchPlatillos:'',
      headersPlatillos: [
        { text: 'ID'            , value: 'idplatillos'    },
        { text: 'Sucursal'      , value: 'sucursal'       },
        { text: 'Horarios'      , value: 'horario'        },
        { text: 'Platillo'      , value: 'platillo'       },
        { text: 'Personas'      , value: 'personas'       },
        { text: 'Precio'        , value: 'precio'         },
      ],
      platillosSeleccionados: [],

      searchExtras:'',
      headersExtras: [
        { text: 'ID'            , value: 'idextras'       },
        { text: 'Producto'      , value: 'extra'          },
        { text: 'Precio'        , value: 'precio'         },
      ],
      extrasSeleccionados: [],

      anticipo:null,
      tipo_pago:null,

      horario: null,

      headersMercancia: [
        { text: 'ID'            , value: 'idextras'       },
        { text: 'Producto'      , value: 'extra'          },
        { text: 'Precio'        , value: 'precio'         },
        { text: 'Cantidad'      , value: 'cantidad'       },
        { text: 'Total'         , value: 'total'          },
      ],

      fechaini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      dialogConfirmaEntrega: false
    }),

    computed: {
      ...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar proveedor' : 'Editar el proveedor'
      },

      total_pago( ){

      	let pagoAdicionales = this.articulosSeleccionados.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);
      	let pagoPlatillos   = this.platillosSeleccionados.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);
      	let pagoExtras      = this.extrasSeleccionados.reduce((acc, producto) => acc + parseFloat( producto.precio ), 0);

      	let sumaTotal = pagoAdicionales + pagoPlatillos + pagoExtras

      	return ( sumaTotal )
      },


      faltante( ){

      	return this.total_pago - this.anticipo

      },

      filterHorarios( ){

      	return this.horarios.filter( el => el.idsucursales == this.sucursal )
      },

      filterPlatillos( ){

      	return this.platillos.filter( el => el.idsucursales == this.sucursal && el.idhorarios == this.horario )

      },

      filterVentasmercancia( ){


        let data = this.ventasmercancia

        if( this.fechaini && this.fechafin ){

          data = data.filter( el => el.fecha_creacion.substr( 0,10 ) >= this.fechaini &&  el.fecha_creacion.substr( 0,10 ) <= this.fechafin )

        }

        return data

      },

      totalTarjeta( ){


        let data = this.ventasmercancia

        if( this.fechaini && this.fechafin ){

          data = data.filter( el => el.fecha_creacion.substr( 0,10 ) >= this.fechaini &&  el.fecha_creacion.substr( 0,10 ) <= this.fechafin )

        }

        data = data.filter( el => el.tipo_pago == 2 )

        return data.reduce((acc, producto) => acc + parseFloat( producto.total ), 0);

      },

      totalEfectivo( ){


        let data = this.ventasmercancia

        if( this.fechaini && this.fechafin ){

          data = data.filter( el => el.fecha_creacion.substr( 0,10 ) >= this.fechaini &&  el.fecha_creacion.substr( 0,10 ) <= this.fechafin )

        }

        data = data.filter( el => el.tipo_pago == 1 )

        return data.reduce((acc, producto) => acc + parseFloat( producto.total ), 0);

      },

      total( ){


        let data = this.ventasmercancia

        if( this.fechaini && this.fechafin ){

          data = data.filter( el => el.fecha_creacion.substr( 0,10 ) >= this.fechaini &&  el.fecha_creacion.substr( 0,10 ) <= this.fechafin )

        }

        return data.reduce((acc, producto) => acc + parseFloat( producto.total ), 0);

      }


    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },

    async created () {
      await this.initialize()
    },

    methods: {
      initialize () {
        this.cargar = true
        this.ventasmercancia = []
        return this.$http.get('ventasmercancia.list').then(response=>{
          this.ventasmercancia = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      formatMoney(value) {
        // Formateamos el número como moneda en dólares (USD)
        return value.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        });
      },

      editItem (item) {
        this.editedIndex = this.ventasmercancia.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.ventasmercancia.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('ventasmercancia.update/' + this.editedItem.idventas_mercancia, this.editedItem).then(response=>{
          this.cargar = true
          this.closeDelete()
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      saveCompra( ){
        this.cargar = true

        const payload = {

          idventas_mercancia  : this.editedItem.idventas_mercancia,
          idautorizo          : this.getdatosUsuario.idusuarios,
          data                : this.editedItem

        }

        // Lo mandapos por el EP
        this.$http.post('mercancias.update', payload).then(response=>{
          this.dialogConfirmaEntrega = false
          this.validarSuccess('Datos actualizados correctamente')
          this.close( )
          this.initialize( )
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    },
  }
</script>


